import { FunctionComponent } from 'react';
import style from './image.module.scss';

export interface ImageProps {
  width: string;
  height: number;
  positionX: number;
  positionY: number;
  src: string;
  alt?: string;
}

type FC = FunctionComponent<ImageProps>;

const Image: FC = (props: ImageProps) => {
  const { width = 'auto', height, positionX, positionY, src } = props;

  return (
    <div className={style.container} style={{ transform: `translate(${positionX}%, ${positionY}%)` }}>
      <img style={{ width: `${width}`, height: `${height}%` }} src={src} alt="Laptop" />
    </div>
  );
};

export default Image;
